import React from "react";
import styles from "./Contact.module.css";
import {
  MapPin,
  Mail,
  Phone,
  Printer,
  Navigation,
} from "lucide-react";
import CustomButton from "../components/CustomButton";
import BackToTop from "../components/BackToTop";
import MapWithConsent from "../components/MapWithConsent";

const Contact: React.FC = () => {
  return (
    <main className={styles.contactPage}>
      <section className={styles.mapSection}>
        <MapWithConsent />
      </section>

      <section className={styles.infoSection}>
        <h2 className={styles.title}>Kontaktieren Sie uns</h2>
        <p className={styles.subtitle}>
          Wir freuen uns auf Ihre Anfrage und stehen Ihnen gerne zur Verfügung.
        </p>

        <div className={styles.contactContainer}>
          <div className={styles.leftCol}>
            <div className={styles.contactItem}>
              <MapPin className={styles.icon} />
              <span>
                Grunewaldstraße 24, 12165 Berlin
              </span>
            </div>
      <div className={styles.contactItem}>
              <Navigation className={styles.icon} />
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Grunewaldstraße+24,+12165+Berlin"
                target="_blank"
                rel="noreferrer"
              >
                Route planen
              </a>
            </div>
            <div className={styles.contactItem}>
              <Printer className={styles.icon} />
              <a href="fax:+493080581928">+49 30 805 819 28</a>
            </div>
            
          </div>

          <div className={styles.rightCol}>
        <div className={styles.contactItem}>
              <Phone className={styles.icon} />
              <a href="tel:+493037436370">+49 30 374 363 70</a>
            </div>


          
<div className={styles.contactItem}>
              <Mail className={styles.icon} />
              <a href="mailto:info@avila-projektmanagement.de">
                info@avila-projektmanagement.de
              </a>
            </div>
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <CustomButton
            text="Zur Startseite"
            to="/"
            variant="filled"
            size="medium"
          />
        </div>

        <BackToTop />
      </section>
    </main>
  );
};

export default Contact;
